import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-3">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-500">
            {contactData.subtitle}
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/60 rounded-xl p-6 md:p-8">
          <p className="text-sm text-foreground-600 leading-relaxed mb-6">
            {contactData.desc}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-400 mb-0.5">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.email}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50">
                <i className="ri-wechat-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-400 mb-0.5">微信公众号</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.wechat}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100">
                <i className="ri-phone-line text-secondary-600 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-400 mb-0.5">客服热线</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.qq}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}